var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-arrow-right"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 12h14"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m12 5 7 7-7 7"
})));
export { SvgArrowRight as ReactComponent };
export default __webpack_public_path__ + "ec518ec573cb2baa03cbd068abc61178.svg";